import { render, staticRenderFns } from "./cashDesk.vue?vue&type=template&id=33d76c6c&scoped=true"
import script from "./cashDesk.vue?vue&type=script&lang=js"
export * from "./cashDesk.vue?vue&type=script&lang=js"
import style0 from "./cashDesk.vue?vue&type=style&index=0&id=33d76c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d76c6c",
  null
  
)

export default component.exports